import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    pageAbbr: (page: string) => string;
    pageFull: (page: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Abbreviated page label, e.g. "pg. 02" */
            pageAbbr: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (page: string): string => __intl__.intl().formatMessage({ id: "media.pageAbbr?c=28dv1qxtz14j4", defaultMessage: "pg. {page}" }, { page: page }));
                },
                enumerable: true,
                configurable: true
            },
            /** Full page label, e.g. "Page 2" */
            pageFull: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (page: number): string => __intl__.intl().formatMessage({ id: "media.pageFull?c=sima2y0057o9", defaultMessage: "Page {page, number}" }, { page: page }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
